export default __webpack_public_path__ + "static/fa-solid-900-3643b955225c3b50cb92902b80801cd8.ttf";